import React from 'react';
import { bool } from 'prop-types';
import { useHeaderContext } from '@context';
import cn from 'classnames';
import {
  Promo,
  Product,
  Account,
  Basket,
  List,
  Search,
  Contact,
  QuickAccessFamilyContainer,
} from './components';
import { SubHeaderPropType } from '../../propTypes';

import styles from './styles/index.module.scss';

const SubHeader = ({
  classNames,
  isSticky,
  isMenuItemsOpened,
  isPromosEnabled,
}) => {
  const {
    isB2B,
    isAuthenticated,
    basketCount,
    products,
    promos,
    hasPromosBeenFetched,
  } = useHeaderContext();
  const className = cn(styles.navigation);
  return (
    <>
      <Product
        products={products}
        className={cn(
          styles.product,
          styles.subHeaderButton,
          classNames.product,
        )}
      />
      {isPromosEnabled ? (
        <Promo
          isB2B={isB2B}
          promos={promos}
          isLoading={!hasPromosBeenFetched}
          className={cn(
            styles.promos,
            styles.subHeaderButton,
            classNames.promo,
          )}
        />
      ) : null}
      <Search
        isB2B={isB2B}
        className={classNames.search}
        isHidden={isMenuItemsOpened}
      />
      {!isSticky && (
        <QuickAccessFamilyContainer
          families={products}
          className={classNames.familiesContainer}
        />
      )}
      <Contact isB2B={isB2B} className={classNames.contact} />
      <List isB2B={isB2B} className={classNames.list} />
      <Account
        isAuthenticated={isAuthenticated}
        isB2B={isB2B}
        className={cn(
          className,
          styles.account,
          styles.subHeaderButton,
          classNames.account,
        )}
      />
      <Basket
        isB2B={isB2B}
        count={basketCount}
        className={cn(
          styles.basket,
          styles.subHeader,
          styles.subHeaderButton,
          classNames.basket,
        )}
      />
    </>
  );
};

SubHeader.propTypes = {
  classNames: SubHeaderPropType,
  isSticky: bool,
  isMenuItemsOpened: bool,
  isPromosEnabled: bool,
};
SubHeader.defaultProps = {
  classNames: {},
  isSticky: false,
  isMenuItemsOpened: true,
  isPromosEnabled: false,
};

SubHeader.displayName = 'SubHeader';

export default SubHeader;
